import styles from '../IMSLDAPValidator.module.scss';
import Base from 'pages/Base/Base';
import TransformedDataTable from './TransformedDataTable';
import { nanoid } from 'nanoid';

const PeoplesoftResults = peoplesoftResults => {
	const headers = [
		{ Value: 'ESO ID (CN)', props: { sort: null, onSortChange: null } },
		{
			Value: 'Manager Flag (managerFlag)',
			props: { sort: null, onSortChange: null },
		},
		{
			Value: 'Groups (memberOf)',
			props: { sort: null, onSortChange: null },
		},
		{ Value: 'Attributes', props: { sort: null, onSortChange: null } },
	];

	const extractGroups = groups => {
		if (groups) {
			const groupArray = groups.map(group => {
				const match = group.match(/CN=([^,]+)/);
				return match[1] ? match[1] : null;
			});
			return groupArray.join('\n');
		} else return groups;
	};

	const extractHRAttributes = hrAttributes => {
		if (hrAttributes) {
			const hrArray = hrAttributes
				.filter(item => item.Value.trim() !== '')
				.map(item => item.Key);
			return hrArray.join('\n');
		} else return hrAttributes;
	};

	const rows = Object.entries(peoplesoftResults).map(([key, data]) => {
		return {
			Cells: {
				'ESO ID (CN)': {
					Value: data.ErrorMessage ? data.ErrorMessage : data.CN,
					Validation: {
						Key: 'true',
						Value: null,
						memberToValidateKey: null,
					},
				},
				'Manager Flag (managerFlag)': {
					Value: data.ManagerFlag,
					Validation: {
						Key: 'true',
						Value: null,
						memberToValidateKey: null,
					},
				},
				'Groups (memberOf)': {
					Value: extractGroups(data.Groups),
					Validation: {
						Key: 'true',
						Value: null,
						memberToValidateKey: null,
					},
				},
				Attributes: {
					Value: extractHRAttributes(data.HRAttributes),
					Validation: {
						Key: 'true',
						Value: null,
						memberToValidateKey: null,
					},
				},
			},
			Key: nanoid(),
		};
	});

	return (
		<Base title='Peoplesoft OU' className={styles.psContainer}>
			<TransformedDataTable
				rows={rows}
				headers={headers}
				className={styles.Table_Overrides2}
			/>
		</Base>
	);
};

export default PeoplesoftResults;
